// Lets a file input accumulate files across multiple browse/capture events
// instead of replacing them each time. Mobile users can snap-a-photo, then
// snap-another, without losing the first.
//
// Opt in by adding data-multi-file to the input.

function setup(input) {
  if (input.dataset.multiFileReady === '1') return;
  input.dataset.multiFileReady = '1';

  const list = document.createElement('ul');
  list.className = 'list-unstyled small mt-2 mb-0 multi-file-list';
  input.after(list);

  const dt = new DataTransfer();

  function render() {
    list.innerHTML = '';
    for (let i = 0; i < dt.files.length; i++) {
      const file = dt.files[i];
      const li = document.createElement('li');
      li.className = 'd-flex align-items-center gap-2 py-1';

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'btn btn-sm btn-link p-0 text-danger';
      remove.setAttribute('aria-label', `Remove ${file.name}`);
      remove.textContent = '✕';
      const idx = i;
      remove.addEventListener('click', () => {
        const kept = new DataTransfer();
        for (let j = 0; j < dt.files.length; j++) {
          if (j !== idx) kept.items.add(dt.files[j]);
        }
        dt.items.clear();
        for (let j = 0; j < kept.files.length; j++) dt.items.add(kept.files[j]);
        input.files = dt.files;
        render();
      });

      const name = document.createElement('span');
      name.textContent = file.name;
      name.className = 'text-truncate';

      const size = document.createElement('span');
      size.className = 'text-muted ms-auto';
      size.textContent = human_size(file.size);

      li.appendChild(remove);
      li.appendChild(name);
      li.appendChild(size);
      list.appendChild(li);
    }
  }

  input.addEventListener('change', () => {
    for (const file of input.files) dt.items.add(file);
    input.files = dt.files;
    render();
  });
}

function human_size(bytes) {
  if (!bytes) return '';
  const units = ['B', 'KB', 'MB', 'GB'];
  let n = bytes, i = 0;
  while (n >= 1024 && i < units.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

function boot() {
  document.querySelectorAll('input[type=file][data-multi-file]').forEach(setup);
}

document.addEventListener('turbolinks:load', boot);
document.addEventListener('DOMContentLoaded', boot);
